import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import PaymentSuccess, { PaymentCancel } from "./pages/PaymentSuccess";
import AccessPage from "./pages/AccessPage";
import { SmoothScroll } from "./components/SmoothScroll";

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/access/:token" element={<AccessPage />} />
        </Routes>
      </SmoothScroll>
      <Toaster theme="dark" position="bottom-center" />
    </BrowserRouter>
  );
}

export default App;
